import { useEffect, useRef } from 'react';
import 'driver.js/dist/driver.css';
import { destroyProductTour, startProductTour } from './runProductTour';

export const START_TOUR_EVENT = 'ambiental:start-tour';

const ProductTour = ({ user, tenant, enabled }) => {
  const userRef = useRef(user);
  const tenantRef = useRef(tenant);
  userRef.current = user;
  tenantRef.current = tenant;
  const who = user?.id || user?.email || user?.username || '';
  const roles = Array.isArray(user?.roles) ? user.roles.join(',') : '';
  const profile = `${tenant?.id || ''}:${tenant?.tenant_profile || ''}:${tenant?.org_type || ''}`;

  useEffect(() => {
    if (!enabled || !who) return undefined;
    const replay = () => startProductTour({
      user: userRef.current,
      tenant: tenantRef.current,
      force: true,
    });
    window.addEventListener(START_TOUR_EVENT, replay);
    const timer = window.setTimeout(() => {
      startProductTour({
        user: userRef.current,
        tenant: tenantRef.current,
        force: false,
      });
    }, 900);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener(START_TOUR_EVENT, replay);
      destroyProductTour();
    };
  }, [enabled, who, roles, profile]);

  return null;
};

export default ProductTour;
